import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";

export interface AtlasClientOptions {
  graphqlUrl: string;
  cachePolicies?: Record<string, unknown>;
}

export function createAtlasClient({ graphqlUrl, cachePolicies }: AtlasClientOptions) {
  return new ApolloClient({
    link: new HttpLink({ uri: graphqlUrl }),
    cache: new InMemoryCache({
      typePolicies: {
        Product: { keyFields: ["productId"] },
        Query: {
          fields: {
            productHs92: {
              keyArgs: ["productLevel"],
              merge(_existing: unknown, incoming: unknown) {
                return incoming;
              },
            },
            productHs12: {
              keyArgs: ["productLevel"],
              merge(_existing: unknown, incoming: unknown) {
                return incoming;
              },
            },
            productHs22: {
              keyArgs: ["productLevel"],
              merge(_existing: unknown, incoming: unknown) {
                return incoming;
              },
            },
            productSitc: {
              keyArgs: ["productLevel"],
              merge(_existing: unknown, incoming: unknown) {
                return incoming;
              },
            },
            countries: {
              merge(_existing: unknown, incoming: unknown) {
                return incoming;
              },
            },
            regions: {
              merge(_existing: unknown, incoming: unknown) {
                return incoming;
              },
            },
            subregions: {
              merge(_existing: unknown, incoming: unknown) {
                return incoming;
              },
            },
            ...cachePolicies,
          },
        },
      },
    }),
  });
}
